import {createRouter, createWebHistory} from 'vue-router'
import useUserStore from '@/stores/user'

// レイアウト - 管理画面
const LayoutAdmin = () => import(/* webpackChunkName: "layout-app" */ '@/components/layouts/LayoutAdmin')
// レイアウト - MyPage
const LayoutMyPage = () => import(/* webpackChunkName: "layout-app" */ '@/components/layouts/LayoutMyPage')

// ページ - 管理画面
const AdminDashboard = () => import(/* webpackChunkName: "page-admin-dashboard" */ '@/components/pages/admin/Dashboard')
// ページ - MyPage(管理者用)
const AdminContracts = () => import(/* webpackChunkName: "page-mypage-dashboard" */ '@/components/pages/admin/Contracts')
// ページ - MyPage 
const MyPageContracts = () => import(/* webpackChunkName: "page-mypage-contracts" */ '@/components/pages/mypage/Contracts')
// 認証 - ログイン
const AuthLogin = () => import(/* webpackChunkName: "auth-login" */ '@/components/pages/auth/Login')

const routes = [
    // 管理画面
    {
        path: '',
        component: LayoutAdmin,
        redirect: {
            name: 'admin-dashboard'
        },
        children: [
            {
                path: 'admin',
                redirect: {
                    name: 'admin-dashboard'
                },
            },
            {
                path: 'admin/dashboard',
                component: AdminDashboard,
                name: 'admin-dashboard',
                meta: {
                    title: '管理画面 - ダッシュボード',
                    auth: true,
                    admin: true,
                },
            },
            {
                path: 'admin/users/:user_id/contracts',
                component: AdminContracts,
                name: 'admin-users-contracts',
                meta: {
                    title: '管理画面 - 顧客契約一覧',
                    auth: true,
                    admin: true,
                },
            }
        ],
    },
    // マイページ
    {
        path: '',
        component: LayoutMyPage,
        redirect: {
            name: 'mypage-contracts'
        },
        children: [
            {
                path: 'mypage',
                redirect: {
                    name: 'mypage-contracts'
                },
            },
            {
                path: 'mypage/contracts',
                component: MyPageContracts,
                name: 'mypage-contracts',
                meta: {
                    title: 'マイページ - 請求一覧',
                    auth: true,
                },
            },
            {
                path: 'mypage/login',
                component: AuthLogin,
                name: 'mypage-login',
                meta: {
                    title: 'マイページ - ログイン',
                },
            },
        ],
    },
]

const router = createRouter({
    history: createWebHistory(),
    base: '/',
    routes,
})

router.beforeEach(async (to, from, next) => {
    // ユーザー情報がない場合は取得する
    if (!useUserStore().user) {
        // 認証情報を取得
        await useUserStore().setUser()
    }
    // 管理画面へのアクセス制限
    if (to.matched.some(record => record.meta.admin)) {
        if (useUserStore().user && useUserStore().user.f_admin) {             // 管理ユーザーのみアクセス可能
            next()
        } else if (useUserStore().user && !useUserStore().user.f_admin) {     // 管理ユーザー以外はマイページへリダイレクト
            next({name: 'mypage-contracts'})
        } else {                                                                // ログインしていない場合はログインページへリダイレクト
            next({name: 'mypage-login'})
        }
    } else if (to.matched.some(record => record.meta.auth)) {
        if (useUserStore().user) {
            next()
        } else {
            next({name: 'mypage-login'})
        }
    } else {
        if (useUserStore().user) {
            next({name: 'admin-dashboard'})
        } else {
            next()
        }
    }
})

export default router
